import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { updateActionsErrors } from 'redux/smartchat/details/actions'
import { setAlternativesActionsErrors } from 'redux/smartchat/alternatives/actions'
import ProcessSentimentViewUI from './ProcessSentimentViewUI'

const ProcessSentimentView = ({ renderType, label, placeholder, dataWay, currentValue, onChange, error }) => {
  const { modalActionRef } = useSelector(store => ({
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const dispatch = useDispatch()
  const [value, setValue] = useState({})
  const [dataToExport, setDataToExport] = useState(currentValue || {})
  const [previewIntegrity, setPreviewIntegrity] = useState({})
  const processSentimentOptions = [
    { value: 'processPositiveSentiment', label: I18n.t('smartchat_actions_processPositiveSentiment') },
    { value: 'processNegativeSentiment', label: I18n.t('smartchat_actions_processNegativeSentiment') }
  ]

  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (renderType === 'action') {
        if (modalActionRef.mode !== 'update') return
        onChange(currentValue)
      }

      let option = null
      const error = { processSentiment: {} }
      const updatedValue = { ...value }
      const updatedPreviewIntegrity = { ...previewIntegrity }

      // Sentiment
      option = processSentimentOptions.find(processSentiment => processSentiment.value === currentValue.intentId)
      if (option) {
        if (updatedPreviewIntegrity.sentiment) updatedPreviewIntegrity.sentiment = null
        updatedValue.sentiment = option
      } else {
        // Error
        if (renderType === 'action') {
          if (updatedValue.sentiment !== null) error.processSentiment.sentiment = I18n.t('smartchat_tooltip_warning_notFound')
        } else {
          updatedPreviewIntegrity.sentiment = I18n.t('smartchat_tooltip_warning_notFound')
        }
      }

      // Update local data
      setValue(updatedValue)

      // // Error reports
      if (renderType === 'action') {
        if (Object.keys(error.processSentiment).length) dataWay?.type === 'alternatives'
          ? dispatch(setAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: error }))
          : dispatch(updateActionsErrors(error))
      } else {
        if (Object.keys(updatedPreviewIntegrity).length) setPreviewIntegrity(updatedPreviewIntegrity)
      }
    }

    return () => isSubscribed = false
  }, [currentValue])

  const onChangeInner = ({ fieldType, fieldData }) => {
    const updatedValue = { ...value }
    const updatedDataToExport = { ...dataToExport }

    // Data to export
    if (fieldType === 'sentiment') {
      if (fieldData) {
        updatedValue.sentiment = fieldData
        updatedDataToExport.intentId = fieldData.value
      }
    }

    // Update local data
    setValue(updatedValue)
    setDataToExport(updatedDataToExport)

    // Export the data
    onChange(updatedDataToExport)
  }

  return (
    <ProcessSentimentViewUI
      renderType={renderType}
      label={label}
      placeholder={placeholder}
      processSentimentOptions={processSentimentOptions}
      value={value}
      onChangeInner={onChangeInner}
      error={error}
      previewIntegrity={previewIntegrity}
    />
  )
}

export default ProcessSentimentView
